import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ALPHAEON_CONTACT_PHONE, capitalizeFirstLetterInEachWord } from 'shared';
import failIcon from 'images/utility-icons/warn.svg';
const SignError = ({ errorTitle, errorMessage }) => {
    return (_jsxs("div", { className: "esign-error-container", children: [_jsx("div", { style: { width: '60px', margin: '10px auto 40px' }, children: _jsx("img", { src: failIcon, alt: "red fail icon" }) }), _jsxs("div", { className: "header-message", children: [_jsx("h2", { children: errorTitle }), _jsx("h4", { children: errorMessage })] })] }));
};
const SignErrorBecauseOfStatus = ({ status }) => {
    return (_jsx(SignError, { errorTitle: `Transaction ${capitalizeFirstLetterInEachWord(status)}`, errorMessage: `Your transaction has been ${status}. Please contact Alphaeon at ${ALPHAEON_CONTACT_PHONE} for more details.` }));
};
export default memo(SignErrorBecauseOfStatus);
